import React, { useEffect, useState } from 'react';
import { Stack, TableBody, TableContainer, TableHead, TableRow, Box } from '@mui/material';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import Table from '../../../components/material-ui/adaptive/Table';
import MyTableBoldCell from '../../../components/material-ui/adaptive/MyTableBoldCell';
import { useTranslation } from 'react-i18next';
import AllCheckbox from '../../../components/material-ui/AllCheckbox';
import { IconCircleCheck, IconHourglass } from '@tabler/icons-react';
import useColor from '../../../hooks/site/useColor';
import { Lock } from '@mui/icons-material';
import { setSelectUser } from '../../../store/apps/usersSlice';
import { useDispatch } from 'react-redux';
import UserSelectActions from './UserSelectActions';
import { useAppSelector } from '../../../store';
import UserTableRow from './UserTableRow';
import { useEventListener } from 'usehooks-ts';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import UserInfoMobile from '../modal/UserInfoMobile';

export const ClearChosenListUserTable = 'UserTable.chosenList.clear';
export const ChangeSelectUser = 'UserTable.selectUserIndx.change';

export default function UserTable({ users = [], beginValueIndex, updateTicker }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { success, grey } = useColor();
  const { isMobile } = useBootstrapSize();
  const userIndex = useAppSelector((state) => state.users.list.selectUser?.userIndex);

  const allListId = users.map((_, indx) => indx);
  const [chosenList, setChosenList] = useState([]);
  const [selectUserIndx, setSelectUserIndx] = useState(userIndex);
  const [openShowUserMobile, setOpenShowUserMobile] = useState(false);

  const currentUser = users[selectUserIndx] || {};

  useEventListener(ClearChosenListUserTable, () => {
    setChosenList([]);
    dispatch(setSelectUser({}));
  });

  useEventListener(ChangeSelectUser, (e) => {
    const { userId } = e.detail;
    console.log('users', users, userId);
    const currentUserIndx = users.findIndex((el) => el[0] == userId);
    console.log('currentUserIndx', currentUserIndx);
    setSelectUserIndx(currentUserIndx);
  });

  useEffect(() => {
    const userId = currentUser[0];
    const login = currentUser[1];
    const type = currentUser[2];
    const status = currentUser[3];
    const isOnline = currentUser[4];
    const blockDep = !!currentUser[6];
    const unreadMes = currentUser[7];
    if (!userId) return;

    const userInfo = {
      userIndex: selectUserIndx,
      userId,
      login,
      status,
      type,
      isOnline,
      blockDep,
      unreadMes
    };
    dispatch(setSelectUser(userInfo));
  }, [selectUserIndx]);

  useEffect(() => {
    setChosenList([]);
  }, [updateTicker]);

  useEffect(() => {
    setSelectUserIndx(userIndex);
  }, [userIndex]);

  const iconByStatus = {
    active: <IconCircleCheck color={success.main} />,
    moderated: <IconHourglass color={grey[400]} />,
    locked: <Lock color="error" />
  };

  const popupTextByStatus = {
    active: t('Active_'),
    moderated: t('For moderation'),
    locked: t('Lock_')
  };

  return (
    <>
      <UserSelectActions setChosenList={setChosenList} chosenList={chosenList} users={users} />
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <MyTableBoldCell isLess>
                <Stack direction={'row'} gap={0} alignItems={'center'}>
                  <AllCheckbox
                    allListId={allListId}
                    chosenList={chosenList}
                    setChosenList={setChosenList}
                  />
                  {t('#')}
                </Stack>
              </MyTableBoldCell>
              <MyTableBoldCell isLess sx={{ pr: 0 }}>
                <Stack>{t('Online')}</Stack>
              </MyTableBoldCell>
              <MyTableBoldCell isLess>
                <Stack direction={'row'} justifyContent={'center'}>
                  {t('Account')}
                </Stack>
              </MyTableBoldCell>
              <MyTableBoldCell isLess>
                <Stack direction={'row'} justifyContent={'center'}>
                  {t('Deposits')}
                </Stack>
              </MyTableBoldCell>
              <MyTableBoldCell isLess sx={{ pl: 0 }}>
                <Stack direction={'row'} justifyContent={'center'}>
                  {`${t('Tg chat')}`}
                </Stack>
              </MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Type')}</MyTableBoldCell>
              <MyTableBoldCell isLess>{t('ID')}</MyTableBoldCell>
              <MyTableBoldCell isLess sx={{ minWidth: 150 }}>
                {t('Login (tg/Email/Phone)')}
              </MyTableBoldCell>
              <ShowContainer condition={isMobile}>
                <MyTableBoldCell isLess sx={{ minWidth: 150 }}></MyTableBoldCell>
              </ShowContainer>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user, index) => (
              <UserTableRow
                key={user[0] + '_' + index}
                index={index}
                user={user}
                beginValueIndex={beginValueIndex}
                iconByStatus={iconByStatus}
                popupTextByStatus={popupTextByStatus}
                isSelected={index == selectUserIndx}
                isChecked={chosenList.includes(index)}
                setChosenList={setChosenList}
                setSelectUserIndx={setSelectUserIndx}
                setOpenShowUserMobile={setOpenShowUserMobile}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <UserInfoMobile
        viewUserId={openShowUserMobile}
        open={isMobile && !!openShowUserMobile}
        closeModal={() => setOpenShowUserMobile(false)}
      />
    </>
  );
}
